import {
  Drawer,
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useState, useEffect, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useAxiosRequests from "../../../hooks/useAxiosRequest";
import ExternalRoutes from "../../../config/ExternalRoutes";
import { MessageContext } from "../../../context/MessageContext";

const CompanyEdit = ({ open, onClose, company, onCompanyUpdated }) => {
  const { sendRequest } = useAxiosRequests();
  const [loading, setLoading] = useState(false);
  const { showSuccess, showError } = useContext(MessageContext);

  const initialValues = {
    name: company?.sctName || "",
    address: company?.sctAddress || "",
    siret: company?.sctSiret || "",
    sctMyUnisoftId: company?.sctMyUnisoftId || "",
    user_id: company?.user_id || "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Le nom est requis"),
    address: Yup.string().required("L'adresse est requise"),
    siret: Yup.string().required("Le SIRET est requis"),
    sctMyUnisoftId: Yup.string().required("L'ID MyUnisoft est requis"),
  });

  const [formKey, setFormKey] = useState(0);
  useEffect(() => {
    setFormKey((k) => k + 1);
  }, [company]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      const body = new FormData();
      if (company?.id) {
        body.append('id', company.id);
      }
      if (values.user_id) {
        body.append('user_id', values.user_id);
      }
      Object.entries(values).forEach(([key, value]) => {
        if (value && key !== "user_id") body.append(key, value);
      });

      const response = await sendRequest({
        method: "POST",
        url: ExternalRoutes.society.add,
        body
      });
      if (response.status === "success") {
        showSuccess(response.message);
        if (onCompanyUpdated) onCompanyUpdated();
      } else {
        showError(response.message || "Erreur inattendue.");
      }
    } catch (error) {
      console.error("Error updating company:", error);
    } finally {
      setLoading(false);
      setSubmitting(false);
      onClose();
    }
  }




  return (
      <Drawer anchor="right" open={open} onClose={onClose}>
        <Box sx={{ width: 400, padding: 3 }}>
          <Typography variant="h6" gutterBottom>
            Modifier la société
          </Typography>
          <Formik
            key={formKey}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ isSubmitting, errors, touched }) => (
              <Form>
                <Field
                  as={TextField}
                  fullWidth
                  label="Nom de la société"
                  name="name"
                  margin="normal"
                  helperText={touched.name && errors.name ? errors.name : ""}
                  error={touched.name && Boolean(errors.name)}
                />
                <Field
                  as={TextField}
                  fullWidth
                  label="Adresse"
                  name="address"
                  margin="normal"
                  helperText={touched.address && errors.address ? errors.address : ""}
                  error={touched.address && Boolean(errors.address)}
                />
                <Field
                  as={TextField}
                  fullWidth
                  label="SIRET"
                  name="siret"
                  margin="normal"
                  helperText={touched.siret && errors.siret ? errors.siret : ""}
                  error={touched.siret && Boolean(errors.siret)}
                />
                <Field
                  as={TextField}
                  fullWidth
                  label="ID MyUnisoft"
                  name="sctMyUnisoftId"
                  margin="normal"
                  helperText={touched.sctMyUnisoftId && errors.sctMyUnisoftId ? errors.sctMyUnisoftId : ""}
                  error={touched.sctMyUnisoftId && Boolean(errors.sctMyUnisoftId)}
                />
                {/* <Field
                  as={TextField}
                  fullWidth
                  label="ID Utilisateur"
                  name="user_id"
                  margin="normal"
                  helperText={touched.user_id && errors.user_id ? errors.user_id : ""}
                  error={touched.user_id && Boolean(errors.user_id)}
                  disabled 
                /> */}

                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
                  <Button variant="outlined" onClick={onClose} disabled={loading || isSubmitting}>
                    Annuler
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading || isSubmitting}
                  >
                    {loading ? <CircularProgress size={24} /> : "Enregistrer"}
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Drawer>
    );
  };

  export default CompanyEdit;